import { Card, Badge } from 'react-bootstrap'
import { EditIcon } from './icons'

function IntegrationCard(props) {
  const isEnabled = !!props.integration.common?.enabled;

  return (
    <Card className='integration-card w-100' style={{ width: '18rem' }}>
      <Card.Body className='d-flex flex-column'>
        <div className='d-flex justify-content-between align-items-start gap-2 mb-2'>
          <Card.Title className='mb-0 text-break'>
            {props.integration.common.site_name}
          </Card.Title>
          <Badge
            bg={isEnabled ? 'success' : 'secondary'}
            className='status-badge'
            pill
          >
            {isEnabled ? 'Activo' : 'Inactivo'}
          </Badge>
        </div>
        <button
          type='button'
          className='edit-button mt-auto'
          onClick={() => props.onEditClick(props.integration)}
        >
          <EditIcon />
          Editar
        </button>
      </Card.Body>
    </Card>
  )
}

export default IntegrationCard
